const handleIframeResize = (event) => {
  const iframeId = event?.data?.iframeId
  const divElements: any = document.querySelector(".widget-theme-wrapper")
  if (divElements) {
    window.parent.postMessage(
      JSON.stringify({
        msg: "screensize",
        isFrom: "smartRez",
        width: window.innerWidth,
        height: divElements?.offsetHeight + 80,
        iframeId,
      }),
      "*"
    )
  }
}

export const setParentIframeHeight = () => {
  try {
    // Remove any previous listeners to prevent duplicates if needed
    window.removeEventListener("message", handleIframeResize)

    // Add the event listener only once
    window.addEventListener("message", handleIframeResize)
  } catch (e) {
    console.log("CATCH ERROR PARENT", e)
  }
}
export const createDropdownOptionsForUnit = (arraylength = 0) => {
  try {
    const arr: any = Array.from({ length: arraylength > 999 ? 999 : arraylength }, (_, index) => ({
      value: index + 1,
      label: `${index + 1}`,
    }))

    // Add {label: '0', value: 0} at the beginning
    arr.unshift({ label: "0", value: 0 })

    return arr
  } catch (e) {
    return []
  }
}
